import { render, staticRenderFns } from "./polls-surveys.vue?vue&type=template&id=4154adf7&scoped=true"
import script from "./polls-surveys.vue?vue&type=script&lang=js"
export * from "./polls-surveys.vue?vue&type=script&lang=js"
import style0 from "./polls-surveys.vue?vue&type=style&index=0&id=4154adf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154adf7",
  null
  
)

export default component.exports